import GridItem from '@/components/video-list/GridItem';
import ListItem from '@/components/video-list/ListItem';
export default {
  props: {
    displayType: {
      type: String,
      default: 'grid'
    },
    videoObject: {
      type: Object,
      default() {
        return {};
      }
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getCols(size) {
      if (this.displayType === 'list') {
        return 12;
      }
      switch (size) {
        case 'sm':
          return '6';
        case 'md':
          return '4';
        case 'lg':
          return '3';
        default:
          return '3';
      }
    }
  },
  components: {
    GridItem,
    ListItem
  }
};